export default __webpack_public_path__ + "static/Final CTA-2bdffa46eb43632ff245dfd0777e6453.webp";